import React, { useState } from 'react';
import { Check, X, Sparkles, Shield, Users, User, Star } from 'lucide-react';
import { Link } from 'react-router-dom';
import { TopBar } from '../components/TopBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
export function PricingPage() {
  const [isAnnual, setIsAnnual] = useState(true);
  return <div className="flex flex-col min-h-screen w-full font-inter bg-white" data-id="element-2615">
      <TopBar data-id="element-2616" />
      <Header data-id="element-2617" />

      {/* Hero Section */}
      <section className="w-full bg-white py-16 md:py-24 border-b border-gray-200" data-id="element-2618">
        <div className="max-w-7xl mx-auto px-6 md:px-12 text-center" data-id="element-2619">
          <h1 className="text-4xl md:text-6xl font-extrabold text-[#111111] mb-6 leading-tight" data-id="element-2620">
            Simple, Honest Pricing for Your
            <br className="hidden md:block" data-id="element-2621" /> Family's Digital Future.
          </h1>
          <p className="text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto leading-relaxed" data-id="element-2622">
            No upsells, no confusing add-ons, and no fear-mongering. Just
            straightforward plans that build your family's digital confidence.
            Choose the plan that's right for you.
          </p>

          {/* Monthly/Annual Toggle */}
          <div className="mt-12 flex items-center justify-center space-x-4" data-id="element-2623">
            <span className={`text-lg font-medium ${!isAnnual ? 'text-[#111111]' : 'text-gray-500'}`} data-id="element-2624">
              Monthly
            </span>
            <button onClick={() => setIsAnnual(!isAnnual)} className="relative w-16 h-8 bg-#[631bb7] rounded-full p-1 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-#[631bb7]" data-id="element-2625">
              <div className={`w-6 h-6 bg-white rounded-full shadow-md transform transition-transform duration-200 ease-in-out ${isAnnual ? 'translate-x-8' : 'translate-x-0'}`} data-id="element-2626" />
            </button>
            <span className={`text-lg font-medium ${isAnnual ? 'text-[#111111]' : 'text-gray-500'}`} data-id="element-2627">
              Annual <span className="text-[#631bb7] text-sm" data-id="element-2628">(Save 20%)</span>
            </span>
          </div>
        </div>
      </section>

      {/* Pricing Tiers */}
      <section className="w-full bg-[#f8f8f8] py-16 md:py-24" data-id="element-2629">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-2630">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-start" data-id="element-2631">
            {/* Foundation (Free) */}
            <div className="bg-white rounded-2xl p-8 border border-gray-200 shadow-sm flex flex-col h-full" data-id="element-2632">
              <div className="mb-6" data-id="element-2633">
                <h3 className="text-2xl font-bold text-[#111111]" data-id="element-2634">
                  Foundation
                </h3>
                <p className="text-gray-500 text-sm mt-1" data-id="element-2635">
                  Essential basics for everyone
                </p>
              </div>
              <div className="mb-8" data-id="element-2636">
                <span className="text-4xl font-extrabold text-[#111111]" data-id="element-2637">
                  $0
                </span>
                <span className="text-gray-500 ml-1" data-id="element-2638">/forever</span>
              </div>
              <Link to="/intro-assessment" className="w-full block text-center py-3 px-4 bg-gray-100 text-[#111111] font-bold rounded-lg hover:bg-gray-200 transition-colors mb-8" data-id="element-2639">
                Start for Free
              </Link>
              <ul className="space-y-4 flex-grow" data-id="element-2640">
                <li className="flex items-start" data-id="element-2641">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-2642" />
                  <span className="text-gray-700 text-sm" data-id="element-2643">1 Member</span>
                </li>
                <li className="flex items-start" data-id="element-2644">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-2645" />
                  <span className="text-gray-700 text-sm" data-id="element-2646">
                    Basic Security Assessment
                  </span>
                </li>
                <li className="flex items-start" data-id="element-2647">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-2648" />
                  <span className="text-gray-700 text-sm" data-id="element-2649">
                    Intro & Level 1 Modules
                  </span>
                </li>
                <li className="flex items-start" data-id="element-2650">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-2651" />
                  <span className="text-gray-700 text-sm" data-id="element-2652">
                    Specialized Guides
                  </span>
                </li>
              </ul>
            </div>

            {/* Individual */}
            <div className="bg-white rounded-2xl p-8 border border-gray-200 shadow-sm flex flex-col h-full relative" data-id="element-2653">
              <div className="mb-6" data-id="element-2654">
                <h3 className="text-2xl font-bold text-[#111111]" data-id="element-2655">
                  Individual
                </h3>
                <p className="text-gray-500 text-sm mt-1" data-id="element-2656">
                  Full access for one person
                </p>
              </div>
              <div className="mb-8" data-id="element-2657">
                <span className="text-4xl font-extrabold text-[#111111]" data-id="element-2658">
                  {isAnnual ? '$79' : '$7.99'}
                </span>
                <span className="text-gray-500 ml-1" data-id="element-2659">
                  {isAnnual ? '/year' : '/mo'}
                </span>
                {isAnnual && <p className="text-green-600 text-sm mt-1 font-medium" data-id="element-2660">
                    Save $16/year
                  </p>}
              </div>
              <Link to="/intro-assessment" className="w-full block text-center py-3 px-4 bg-[#1a0647] text-white font-bold rounded-lg hover:bg-[#2d0b75] transition-colors mb-8" data-id="element-2661">
                Choose Individual
              </Link>
              <ul className="space-y-4 flex-grow" data-id="element-2662">
                <li className="flex items-start" data-id="element-2663">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-2664" />
                  <span className="text-gray-700 text-sm" data-id="element-2665">1 Member</span>
                </li>
                <li className="flex items-start" data-id="element-2666">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-2667" />
                  <span className="text-gray-700 text-sm" data-id="element-2668">
                    Everything in Foundation
                  </span>
                </li>
                <li className="flex items-start" data-id="element-2669">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-2670" />
                  <span className="text-gray-700 text-sm font-semibold" data-id="element-2671">
                    Full Access to All 37 Modules
                  </span>
                </li>
                <li className="flex items-start" data-id="element-2672">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-2673" />
                  <span className="text-gray-700 text-sm" data-id="element-2674">
                    Personal Dashboard & Scoring
                  </span>
                </li>
                <li className="flex items-start" data-id="element-2675">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-2676" />
                  <span className="text-gray-700 text-sm" data-id="element-2677">
                    Personalized Task Queue
                  </span>
                </li>
              </ul>
            </div>

            {/* Family (Best Value) */}
            <div className="bg-white rounded-2xl p-8 border-2 border-[#631bb7] shadow-xl flex flex-col h-full relative transform md:-translate-y-4" data-id="element-2678">
              <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-[#631bb7] text-white px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wide" data-id="element-2679">
                Best Value
              </div>
              <div className="mb-6 mt-2" data-id="element-2680">
                <h3 className="text-2xl font-bold text-[#111111]" data-id="element-2681">Family</h3>
                <p className="text-gray-500 text-sm mt-1" data-id="element-2682">
                  Complete protection for everyone
                </p>
              </div>
              <div className="mb-8" data-id="element-2683">
                <span className="text-4xl font-extrabold text-[#111111]" data-id="element-2684">
                  {isAnnual ? '$199' : '$19.99'}
                </span>
                <span className="text-gray-500 ml-1" data-id="element-2685">
                  {isAnnual ? '/year' : '/mo'}
                </span>
                {isAnnual && <p className="text-green-600 text-sm mt-1 font-medium" data-id="element-2686">
                    Save $40/year
                  </p>}
              </div>
              <Link to="/intro-assessment" className="w-full block text-center py-3 px-4 bg-[#631bb7] text-white font-bold rounded-lg hover:bg-[#521099] transition-colors mb-8 shadow-md" data-id="element-2687">
                Choose Family
              </Link>
              <ul className="space-y-4 flex-grow" data-id="element-2688">
                <li className="flex items-start" data-id="element-2689">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-2690" />
                  <span className="text-gray-700 text-sm font-bold" data-id="element-2691">
                    Up to 6 Members
                  </span>
                </li>
                <li className="flex items-start" data-id="element-2692">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-2693" />
                  <span className="text-gray-700 text-sm" data-id="element-2694">
                    Everything in Individual
                  </span>
                </li>
                <li className="flex items-start" data-id="element-2695">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-2696" />
                  <span className="text-gray-700 text-sm font-semibold" data-id="element-2697">
                    Family Coordination Dashboard
                  </span>
                </li>
                <li className="flex items-start" data-id="element-2698">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-2699" />
                  <span className="text-gray-700 text-sm" data-id="element-2700">
                    Role-Based Views
                  </span>
                </li>
                <li className="flex items-start" data-id="element-2701">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-2702" />
                  <span className="text-gray-700 text-sm" data-id="element-2703">
                    Shared Task Queue & Delegation
                  </span>
                </li>
                <li className="flex items-start" data-id="element-2704">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-2705" />
                  <span className="text-gray-700 text-sm" data-id="element-2706">
                    Cross-Family Progress Tracking
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Lifetime Offer Section */}
      <section className="w-full bg-[#1a0647] py-16 md:py-24 relative overflow-hidden" data-id="element-2707">
        {/* Background decorative elements */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-2708">
          <div className="absolute top-10 left-10 w-64 h-64 bg-[#8041bf] rounded-full filter blur-3xl" data-id="element-2709"></div>
          <div className="absolute bottom-10 right-10 w-96 h-96 bg-[#00f4f8] rounded-full filter blur-3xl" data-id="element-2710"></div>
        </div>

        <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-2711">
          <div className="text-center mb-12" data-id="element-2712">
            <div className="inline-block bg-[#631bb7] text-white px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wide mb-6" data-id="element-2713">
              Limited-Time Founding Member Offer
            </div>
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-2714">
              Become a Founding Member.
              <br data-id="element-2715" /> Pay Once, Protected Forever.
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed" data-id="element-2716">
              For our first 1,000 customers, we're offering exclusive lifetime
              access. Secure your family's digital future and support our
              mission to make the internet a safer place for everyone. This
              offer will not be available again.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-2717">
            {/* Lifetime Individual */}
            <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-2xl p-8 border border-white border-opacity-20 hover:bg-opacity-15 transition-all" data-id="element-2718">
              <div className="flex items-center justify-between mb-6" data-id="element-2719">
                <h3 className="text-2xl font-bold text-white" data-id="element-2720">
                  Lifetime Individual
                </h3>
                <User className="text-[#00f4f8] w-8 h-8" data-id="element-2721" />
              </div>
              <div className="mb-6" data-id="element-2722">
                <span className="text-5xl font-extrabold text-white" data-id="element-2723">$199</span>
                <p className="text-[#00f4f8] font-medium mt-2" data-id="element-2724">
                  One-Time Payment
                </p>
              </div>
              <p className="text-gray-300 mb-8" data-id="element-2725">
                Includes all future updates to the Individual Plan.
              </p>
              <button className="w-full py-4 px-6 bg-white text-[#1a0647] font-bold rounded-lg hover:bg-gray-100 transition-colors" data-id="element-2726">
                Get Lifetime Individual
              </button>
            </div>

            {/* Lifetime Family */}
            <div className="bg-gradient-to-br from-[#631bb7] to-[#521099] rounded-2xl p-8 border border-white border-opacity-20 shadow-2xl transform md:scale-105" data-id="element-2727">
              <div className="flex items-center justify-between mb-6" data-id="element-2728">
                <h3 className="text-2xl font-bold text-white" data-id="element-2729">
                  Lifetime Family
                </h3>
                <Users className="text-white w-8 h-8" data-id="element-2730" />
              </div>
              <div className="mb-6" data-id="element-2731">
                <span className="text-5xl font-extrabold text-white" data-id="element-2732">$599</span>
                <p className="text-white text-opacity-90 font-medium mt-2" data-id="element-2733">
                  One-Time Payment
                </p>
              </div>
              <p className="text-white text-opacity-80 mb-8" data-id="element-2734">
                Includes all future updates to the Family Plan for up to 6
                members.
              </p>
              <button className="w-full py-4 px-6 bg-[#00f4f8] text-[#1a0647] font-bold rounded-lg hover:bg-[#00e0e4] transition-colors shadow-lg" data-id="element-2735">
                Get Lifetime Family
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Competitive Comparison */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-2736">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-2737">
          <div className="text-center mb-12" data-id="element-2738">
            <h2 className="text-3xl md:text-4xl font-bold text-[#111111] mb-4" data-id="element-2739">
              Why Overpay for Anxiety When You Can Invest in Capability?
            </h2>
          </div>

          <div className="overflow-x-auto" data-id="element-2740">
            <table className="w-full max-w-5xl mx-auto border-collapse" data-id="element-2741">
              <thead data-id="element-2742">
                <tr data-id="element-2743">
                  <th className="text-left py-4 px-6 font-bold text-gray-500 uppercase text-sm tracking-wider border-b-2 border-gray-100" data-id="element-2744"></th>
                  <th className="text-left py-4 px-6 border-b-2 border-[#631bb7]" data-id="element-2745">
                    <div className="text-xl font-bold text-[#631bb7]" data-id="element-2746">
                      Caveo
                    </div>
                  </th>
                  <th className="text-left py-4 px-6 border-b-2 border-gray-100" data-id="element-2747">
                    <div className="text-xl font-bold text-gray-600" data-id="element-2748">
                      Norton 360 / Aura
                    </div>
                  </th>
                  <th className="text-left py-4 px-6 border-b-2 border-gray-100" data-id="element-2749">
                    <div className="text-xl font-bold text-gray-600" data-id="element-2750">
                      Geek Squad
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-2751">
                {[{
                label: 'Philosophy',
                caveo: 'Builds your capability',
                competitor1: 'Sells reactive alerts & fear',
                competitor2: 'Profits from your tech breaking'
              }, {
                label: 'Cost',
                caveo: 'Starts at $7.99/mo',
                competitor1: '$12 - $35/mo',
                competitor2: '$99+ per incident'
              }, {
                label: 'Experience',
                caveo: 'Plain-English guidance',
                competitor1: 'Confusing technical jargon',
                competitor2: 'In-person visit required'
              }, {
                label: 'Incentive',
                caveo: 'We win when you feel confident',
                competitor1: 'They win when you stay anxious',
                competitor2: 'They win when you have problems'
              }, {
                label: 'Outcome',
                caveo: 'Digital Independence',
                competitor1: 'Dependency & Confusion',
                competitor2: 'A temporary fix'
              }].map((row, idx) => <tr key={idx} className={idx % 2 === 0 ? 'bg-gray-50' : 'bg-white'} data-id="element-2752">
                    <td className="py-6 px-6 font-bold text-[#111111]" data-id="element-2753">
                      {row.label}
                    </td>
                    <td className="py-6 px-6 font-medium text-[#631bb7] bg-[#631bb7] bg-opacity-5" data-id="element-2754">
                      {row.caveo}
                    </td>
                    <td className="py-6 px-6 text-gray-600" data-id="element-2755">
                      {row.competitor1}
                    </td>
                    <td className="py-6 px-6 text-gray-600" data-id="element-2756">
                      {row.competitor2}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="w-full bg-[#f8f8f8] py-16 md:py-24 border-t border-gray-200" data-id="element-2757">
        <div className="max-w-4xl mx-auto px-6 md:px-12" data-id="element-2758">
          <h2 className="text-3xl md:text-4xl font-bold text-[#111111] mb-12 text-center" data-id="element-2759">
            Your Questions, Answered.
          </h2>
          <div className="space-y-6" data-id="element-2760">
            {[{
            q: 'Can I cancel my subscription at any time?',
            a: 'Yes. You can cancel your monthly or annual plan at any time from your account settings. No questions asked. Your plan will remain active until the end of the current billing period.'
          }, {
            q: 'What happens when you add new modules or features?',
            a: "All new modules and feature updates are included in the Individual, Family, and Lifetime plans at no extra cost. Our platform is constantly evolving to meet new threats, and you'll always have the latest protection."
          }, {
            q: 'How does the Family Plan work for different family members?',
            a: "The Family Plan gives you a central dashboard to invite up to 5 other family members. You can use our role-based views to see different information; for example, an adult child can see their parent's progress and help them with tasks, while the parent sees a simplified view focused on their own learning."
          }, {
            q: 'Is the Free (Foundation) plan free forever?',
            a: "Yes. The Foundation plan is free forever. It's a great way to get started with our basic security assessment and introductory modules to see how Caveo works."
          }, {
            q: 'What if I’m not satisfied?',
            a: "We offer a 30-day money-back guarantee on all paid plans, including lifetime memberships. If you're not happy for any reason, just let us know within 30 days of your purchase for a full refund."
          }].map((faq, index) => <div key={index} className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm" data-id="element-2761">
                <h3 className="text-lg font-bold text-[#111111] mb-2" data-id="element-2762">
                  {faq.q}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-2763">{faq.a}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-2764">
        <div className="max-w-7xl mx-auto px-6 md:px-12 text-center" data-id="element-2765">
          <h2 className="text-3xl md:text-5xl font-bold text-[#111111] mb-6" data-id="element-2766">
            Ready to build your family's digital confidence?
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-10" data-id="element-2767">
            Take the first step toward a safer, simpler digital life. Start with
            a free assessment or choose a plan to unlock the full power of Caveo
            today.
          </p>
          <Link to="/intro-assessment" className="inline-block bg-#[631bb7] text-white px-10 py-4 rounded-lg font-bold text-lg hover:bg-#[521099] transition-all shadow-lg transform hover:-translate-y-1" data-id="element-2768">
            Get Started for Free
          </Link>
        </div>
      </section>

      <Footer data-id="element-2769" />
    </div>;
}